var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "alert alert-success p-0" }, [
    _c(
      "table",
      { staticClass: "table table-hover table-sm mt-0 mb-0 closeorder_data" },
      [
        _c("tbody", [
          _c("tr", [
            _c("td", { staticClass: "border-0" }, [
              _vm._v("Дата и время создания (поступления)"),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "border-0" }, [
              _vm._v(
                _vm._s(_vm.printDate(_vm.order.created_at, "DD.MM.YYYY HH:mm"))
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Сумма заявки / Курс")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    Math.round(+_vm.order.price * +_vm.order.rate * 100) / 100
                  ) +
                  " /\n        " +
                  _vm._s(Math.round((1 / _vm.order.rate) * 100) / 100) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Почтовые р. / з.п. курьера")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.order.post_expenses ?? 0) +
                  "\n        /\n        " +
                  _vm._s(_vm.order.salary ?? 0) +
                  "\n        (" +
                  _vm._s(_vm.printSumByTitle("expenses")) +
                  ")\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Доход после логистики")]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.printSumByTitle("cost")))]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Себестоимость препаратов")]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.printSumByTitle("costDrugs")))]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Прибыль")]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.printSumByTitle("income")))]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Отчет")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                _vm._s(_vm.printDate(_vm.order.report_date, "DD.MM.YYYY HH:mm"))
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }